/*
 * Reset Password Via Email Ctrl
 *
 */
module.controller('resetpasswordCtrl', ['$scope', '$state', '$http', 'baseURI', 'Transform', 'SECURITY_QUESTIONS', '$window', '$timeout', 'checkEmailService', '$rootScope', function ($scope, $state, $http, baseURI, Transform, SECURITY_QUESTIONS, $window, $timeout, checkEmailService, $rootScope){
  var resetPasswordURL = baseURI + 'card/resetpassword';
  $scope.showValidateEmail = false;
  $scope.isEmailUnique = false;
  $scope.showUsioSupport = $scope.brand.name === 'akimbo';
  $scope.latestAgeYear = new Date().getFullYear() - 18;

  if ($scope.brand.ssoHide) {
    $window.location.href = $scope.brand.homeUrl;
    return;
  }

  if(!$scope.formData.username && $rootScope.step1FormData){
    $scope.formData = $rootScope.step1FormData;
  } else {
    $rootScope.step1FormData = null;
  }

  $scope.attemptEmailVerification = function(resetForm){
    if(resetForm.$valid){
      checkEmail($scope.formData.Email);
    } else {
      $scope.attempted = true;
    }
  };

  $scope.attemptReset = function(resetForm){
    if(resetForm.$valid){
      resetPassword();
    } else {
      $scope.attempted = true;
    }
  };

  $scope.confirmPWMatch = function(){
    if($scope.formData.Password === $scope.formData.Password1){
      $scope.resetForm.Password1.$setValidity('matches', true);
    } else {
      $scope.resetForm.Password1.$setValidity('matches', false);
    }
  };

  var transformDOB = function(){
    var dobDay = ($scope.formData.Dob2 < 10 ? ('0' + $scope.formData.Dob2) : $scope.formData.Dob2);
    var dobMonth = ($scope.formData.Dob1 < 10 ? ('0' + $scope.formData.Dob1) : $scope.formData.Dob1);
    var dob = $scope.formData.Dob3 + '-' + dobMonth + '-' + dobDay;
    return dob;
  };

  // check CH email using check email service
  var checkEmail = function(email){
    if(email){
      checkEmailService.validate(email, function(isEmailUnique){
        if(isEmailUnique){
          $scope.isEmailUnique = true;
          $scope.attempted = true;
        } else {
          $scope.isEmailUnique = false;
          verifyEmail();
        }
      });
    }
  };

  var getResetType = function(){
    $http.get(baseURI + 'card/resetpassword/' + $scope.formData.Email)
      .then(function(resp){
        $scope.formData.cardType = resp.data.Data.CardType;
        $scope.formData.username = resp.data.Data.Username;
        $state.go('root.resetpassword.step2');
      })
      .catch(function(err){
        $state.go('root.resetpassword.error');
      });
  };

  var resetPassword = function(){
    $scope.loading = true;
    var resetRequest = {
      Password: $scope.formData.Password,
      Email: $scope.formData.Email,
      _key: $scope.brand.api_key
    };

    if($scope.formData.cardType == 'primary'){
      resetRequest.LastFourSSN = $scope.formData.Ssn;
      resetRequest.DOB = transformDOB();
    }

    $http({
      method: 'PUT',
      url: resetPasswordURL,
      headers: {'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'},
      data: Transform.encode(resetRequest)
    }).then(function (resp){
      var data = resp.data;

      $scope.loading = false;
      if(data.Success){
        if (navigator.userAgent.indexOf('iPhone OS') > -1 ) {
          $state.go('root.resetpassword.mobilesuccess');
        } else {
          $state.go('root.resetpassword.success');
        }
      } else {
        $state.go('root.resetpassword.error');
      }
    }).catch(function (error){
      $scope.loading = false;
      $state.go('root.resetpassword.error');
    });
  };

  // Verification email process
  var verifyEmail = function(){
    $scope.formData.verificationMethod = 'email';
    $scope.verificationMethodIsPhone = $scope.formData.verificationMethod === 'phone';
    $scope.verificationMethodIsEmail = $scope.formData.verificationMethod === 'email';

    createVerificationCode();
  };

  // Make request for validation Code
  var createVerificationCode = function(){
    $scope.loading = true;
    var reqData = {
      VerificationType: $scope.formData.verificationMethod,
      Contact: $scope.formData.verificationMethod === 'phone' ? $scope.formData.phone : ($scope.formData.email || $scope.formData.Email),
      _key: $scope.brand.api_key
    };

    $http({
      url: baseURI + 'member/verification',
      method: 'POST',
      headers: {'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'},
      data: Transform.encode(reqData)
    }).then(function(resp){
      var data = resp.data;

      $scope.loading = false;
      if(data.Success){
        // Open the modal
        $scope.showValidateEmail = true;
        startCountDown();
      } else {
        $scope.alertError.show = true;
        alert('Sorry, we were unable to verify your email address at this time. Please try again later.');
      }
    }).catch(function(error){
      $scope.loading = false;
      alert('Sorry, we were unable to verify your email address at this time. Please try again later.');
    });
  };

  // User is manually submitting code
  $scope.submitCode = function(){
    if(!$scope.formData.VerificationCode){
      $scope.attemptedVerify = true;
      $scope.invalidVerify = false;
    } else {
      $scope.loading = true;
      $scope.attemptedVerify = false;
      var verifiedReq = {
        VerificationType: $scope.formData.verificationMethod,
        Contact: $scope.formData.verificationMethod === 'phone' ? $scope.formData.phone : ($scope.formData.email || $scope.formData.Email),
        VerificationCode: $scope.formData.VerificationCode
      };

      $http({
        url: baseURI + 'member/verification',
        method: 'PUT',
        headers: {'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'},
        data: Transform.encode(verifiedReq)
      }).then(function (resp){
        var data = resp.data;

        $scope.loading = false;
        $scope.invalidVerify = !data.Success;
        if(data.Success){
          $scope.stopTimeout();
          successVerification();
        }
      }).catch(function(error){
        $scope.invalidVerify = true;
        $scope.loading = false;
      });
    }
  };

  // User clicks on resend email link
  $scope.reSend = function(){
    $scope.stopTimeout();
    $scope.loadingEmailVerification = true;
    createVerificationCode();
  };

  // Close the modal
  $scope.close = function(){
    if ($scope.showSelectVerificationMethod) {
      $scope.showSelectVerificationMethod = false;
    }
    else {
      $scope.stopTimeout();
      $scope.showValidateEmail = false;
    }
  };

  // User has successfully completed email verification
  var successVerification = function(){
    $rootScope.step1FormData = $scope.formData;
    $scope.$parent.verifiedEmail = true;
    $scope.loadingEmailVerification = true;
    $scope.showValidateEmail = false;

    getResetType();
  };

  var startCountDown = function() {
    $scope.counter = 1200;

    $scope.onTimeout = function(){
      $scope.counter--;
      if($scope.counter > 1){
        myTimeout = $timeout($scope.onTimeout, 1000);
      } else {
        $scope.stopTimeout();
        $scope.showValidateEmail = false;
      }
    };

    // Create the promise
    var myTimeout = $timeout($scope.onTimeout, 1000);

    // Cancel the promise
    $scope.stopTimeout = function() {
      $timeout.cancel(myTimeout);
    };

  };

}]);
